<template>
  <div v-if="!loadingSubmitted" class="q-pa-md q-gutter-md justify-center">
    <q-card class="my-card justify-center" flat>
      <q-card-section>
        <h1 class="text-h6">Create new account</h1>
        <h2 class="text-subtitle1">Already have an account? <router-link to="/user/signin" class="normal-link" style="cursor: pointer">Log in here</router-link></h2>
      </q-card-section>
      <q-card-section v-if="!loadingSubmitted">
        <q-form
          class="q-gutter-sm"
        >
          <q-input
            outlined
            square
            stack-label
            color="secondary"
            type="text"
            required
            v-model="displayName"
            label="First Name*"
            lazy-rules
            :rules="[ val => val && val.length > 0 || 'Please type something']"
          />
          <q-input
            outlined
            square
            stack-label
            type="email"
            color="secondary"
            required
            v-model="email"
            label="E-mail*"
            hint="user@provider.com"
            lazy-rules
            :rules="[ val => val && val.length > 0 || 'Please type something']"
          />

          <q-input
            outlined
            square
            stack-label
            type="password"
            color="secondary"
            required
            v-model="password"
            minlength="6"
            label="Password*"
            lazy-rules
          />

          <address-autocomplete @place="updateAddress" :key="addressKey" hint="i.e.: Wollongong, NWS, Australia" :address="address" />
          
          <div class="col-12 col-md-6 q-my-md">
            <q-btn label="Sign Up" class="full-width square" size="md" :loading="loadingSubmitted" @click="generateToken()" unelevated color="secondary"/>
          </div>
          <q-banner v-if="error" round class="text-white bg-red">
            {{error}}
            <template v-slot:action>
              <q-btn flat label="Dismiss" @click="error = ''" />
            </template>
          </q-banner>
        </q-form>


      <recaptcha @callback="handleSubmit" ref="recaptcha" />
      </q-card-section>
    </q-card>
  </div>
  <div class="q-pa-md row q-gutter-md justify-center" v-else>
    <Spinner/>
  </div>
  
</template>

<script>
import {nextTick, ref, watch} from "vue";
// import useSignup from '@/composables/useSignup'
import Spinner from "@/components/Spinner"
import AddressAutocomplete from "@/components/AddressAutocomplete"
import { inject } from 'vue'
import {useStore} from "vuex"
import router from "@/router";
import VueCookies from 'vue-cookies'
import Recaptcha from "@/components/Recaptcha"

export default {
  name: "User_SignUp",
  components: {Spinner, Recaptcha, AddressAutocomplete},
  setup(){
    //refs
    const displayName = ref('')
    const email = ref('')
    const password = ref('')
    const error = ref(null)
    const loadingSubmitted = ref(false)
    const axios = inject('axios')
    const store = useStore()
    const recaptcha = ref(null)
    const addressCountry = ref(null)
    const addressDistrict  = ref(null)
    const addressCity = ref(null)
    const address = ref(null)
    const addressKey = ref(0)
    const addressLat  = ref(null)
    const addressLon = ref(null)

    // const {error, signup} = useSignup()

    const updateAddress = (place) => {
      address.value = place.formatted_address
      addressCountry.value = getAddressValue(place.address_components, 'country')
      addressDistrict.value = getAddressValue(place.address_components, 'administrative_area_level_1')
      addressCity.value = getAddressValue(place.address_components, 'administrative_area_level_2')
      addressLat.value = place.geometry.location.lat()
      addressLon.value = place.geometry.location.lng()
    }

    const getAddressValue = (array, key) => {
      let filter = array.filter(e => {
        if (e.types.includes(key)) return e
      })

      if (filter.length > 0) return filter[0].short_name
      return ''
    }

    const handleSubmit = async (token) => {
      try {
        loadingSubmitted.value = true
        let data = {
          email: email.value,
          password: password.value,
          name: displayName.value,
          addressCity: addressCity.value,
          addressDistrict: addressDistrict.value,
          addressCountry: addressCountry.value,
          addressLat: addressLat.value,
          addressLon: addressLon.value
          // anonymousGuid: (store.getters.isAnonymous) ? store.getters.anonymousId : null
        }
        let resp
        if (store.getters.isAnonymous && store.getters.stateUser) {
          let response = await store.dispatch('anonymousLogin', store.getters.stateUser.anonymousGuid)
          
          store.commit( 'setUser', response.data );
          
          resp = await axios.put(`${process.env.VUE_APP_URL}/users/${store.getters.stateUser.id}?isNew=true`, data)
          
        } else {
          resp = await axios.post(`${process.env.VUE_APP_URL}/users`, { ...data, token: token })
        }

        await store.commit('setUser', resp.data)
        
        await store.commit('setAnonymous', null)

        await store.commit('setAnonymous', false)

        VueCookies.remove('anonymousGuid')

        router.push({name: 'Home'})
      } catch(err) {
        if (err.response) {
          // Request made and server responded
          error.value = err.response.data.detail
          gtag('event', 'exception', {'fatal': true, 'description': err.response.data.detail, 'method': 'User_Signup.handleSubmit'})
        } else {
          // Something happened in setting up the request that triggered an Error
          error.value = err.message
        }
      } finally {
        loadingSubmitted.value = false
      }
    }

    const generateToken = () => {
      recaptcha.value?.execute()
    }
    
    return {displayName, email, password, handleSubmit, error, loadingSubmitted, generateToken, recaptcha, address, addressKey, updateAddress}
  }
}
</script>

<style scoped>

</style>